import { forwardRef } from 'react';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useSearchableMenu } from './SearchableMenuContext';
import { SearchInputElement, SearchableMenuInputContainer } from './styled';
export const SearchableMenuInput = forwardRef((props, ref) => {
    const { disabled, placeholder } = props;
    const { setOpen } = useSearchableMenu();
    return (<SearchableMenuInputContainer ref={ref}>
      <Falcon icon="magnifying-glass" $color="text.100"/>
      <SearchInputElement as="button" type="button" disabled={disabled} onClick={() => setOpen(true)}>
        {placeholder}
      </SearchInputElement>
    </SearchableMenuInputContainer>);
});
